import { Factory } from '../../services/Factory';

import IHttpService = angular.IHttpService;

export interface IBasicViewerScope extends angular.IScope {
  filePath;
  resource;
  content: string;
  isLargeText: boolean;
  showLargeText: boolean;
  ngShow: boolean;
  ngHide: boolean;
  isHtml: boolean;
}

export interface IBasicViewerAttributes extends angular.IAttributes {
}

export class BasicViewer implements angular.IDirective {
  public restrict: string = 'E';
  public link: (scope: IBasicViewerScope, element: angular.IAugmentedJQuery, attrs: IBasicViewerAttributes) => void;
  public templateUrl: string;
  public maxTextBytes: number;
  public scope = {filePath: '=ngModel', resource: '=', ngShow: '=', ngHide: '=', isHtml: '='};
  public require = ['ngModel'];

  constructor(resourceService: app.services.resources.ResourceService, $http: IHttpService) {
    this.templateUrl = "partials/review/basic_viewer.html";
    this.maxTextBytes = 1000000;
    this.link = (scope: IBasicViewerScope, element: angular.IAugmentedJQuery, attrs: IBasicViewerAttributes) => {

      scope.$watch("filePath", path => {
        scope.content = "";
        scope.isLargeText = (scope.resource && scope.resource.textBytes >= this.maxTextBytes);
        scope.showLargeText = false;

        if (path && !scope.isLargeText) {
          this.LoadText($http, scope);
        }
      });

      scope.$watch("showLargeText", showLargeText => {
        if (scope.filePath && scope.isLargeText && showLargeText) {
          this.LoadText($http, scope);
        }
      });
    }
  }

  private LoadText($http: IHttpService, scope: IBasicViewerScope) {
    let path = scope.filePath;
    if (path) {
      // console.log(path);
      // let filePath = path.$$unwrapTrustedValue();
      let filePath = path;
      if (filePath) {
        $http.get(filePath)
          .then(response => scope.content = response.data.toString());
      }
    }

  }

}

frontendApp.directive("iioBasicViewer", ["ResourceService", "$http", Factory.Create(BasicViewer)]);
